import i18n from "../i18n";
import React from "react";
import _ from "lodash";
import moment from "moment";
import {
  PageList,
  ENUM_FORM_DISPLAY,
} from "./pageList";
import { Text } from "@mantine/core";

import { useCellRender } from "../hooks/useCellRender";
import { useAuthUser } from "react-auth-kit";
import { useTabNavigate } from "../hooks/useTabNavigate";
import { resolveEntityPath } from "../utils/resolveEntityPath";

const ClientOrderHistory = ({ form, ...props }) => {
  const clientId = _.get(form.values, "_id");
  const [cellRender] = useCellRender();
  const auth = useAuthUser();
  const tabNav = useTabNavigate();
  const orderLinkPath = resolveEntityPath("order", auth()?.userRole);

  const openOrder = (e, order) => {
    e.preventDefault();
    if (!order?._id || !orderLinkPath) return;
    if (tabNav.enabled) {
      tabNav.openDetail({
        pathname: orderLinkPath,
        id: order._id,
        mode: "edit",
        label: order.code,
      });
      return;
    }
    window.open(`${orderLinkPath}?id=${order._id}&mode=edit`, "_blank");
  };

  const orderFormSchema = {
    display: {
      mode: ENUM_FORM_DISPLAY.FULLSCREEN,
      // size: "xl",     //xs, sm, xl  ....100%
      // position:"right"
    },
  };

  const tableSchema = {
    name: "clientOrderHistory",
    preQuery: { client: clientId },
    select:
      "code product productType provider productCategory policyNumber payment status signedDate",
    searchableFields: [
      "code",
      "product.name",
      "provider.name",
      "productType.name",
      "status",
      "provider",
      "productType",
    ],

    columns: [
      {
        field: "signedDate",
        headerName: "Sign Date",
        cellRender: (col, order) =>
          order.signedDate
            ? moment(order.signedDate).format("YYYY-MM-DD")
            : "-",
      },
      {
        field: "productCategory",
        headerName: "Product Category",
        sortable: true,
        cellRender: (col, data) =>
          cellRender.ProductCategory(
            data.productCategory ?? data.product?.category,
          ),
      },
      {
        field: "code",
        headerName: "Code",
        cellRender: (col, order) => (
          <div>
            <Text
              component="a"
              style={{ textDecoration: "none", cursor: "pointer" }}
              onClick={(e) => openOrder(e, order)}
            >
              {order?.code}
            </Text>
            <Text color="dimmed"> {order?.policyNumber} </Text>
          </div>
        ),
      },
      {
        field: "product",
        headerName: "Product",
        sortable: true,
        cellRender: (col, data) => {
          if (data.product) return cellRender.ProductInfo(data.product);
          if (data.productType || data.provider)
            return <Text color="dimmed">{cellRender.ProductInfo2(data)}</Text>;
        },
      },
      { field: "payment.payMode", headerName: "Pay Mode" },
      {
        field: "payment.premium",
        headerName: "Premium",
        cellRender: (col, order) =>
          cellRender.Currency(order.payment?.premium, order.payment?.currency),
      },
      {
        field: "status",
        headerName: "Status",
        cellRender: (col, order) => cellRender.Order.status(order.status),
      },
      {
        field: "_filterProductCategory",
        headerName: "Product Category",
        filterOnly: true,
        filterable: true,
        filter: {
          apiEntity: "order",
          field: "productCategory",
          label: "Product Category",
          width: 250,
          height: 300,
          populate: {
            model: "ProductCategory",
            select: "name cname code shortName",
            labelField: "name",
            sort: { code: 1 },
          },
        },
      },
      {
        field: "_filterProductTypeClass",
        headerName: "Product Type (Class)",
        filterOnly: true,
        filterable: true,
        filter: {
          apiEntity: "order",
          field: "productType",
          label: "Product Type (Class)",
          width: 350,
          height: 300,
          populate: {
            model: "ProductType",
            select: "name cname code shortName",
            labelField: "name",
            sort: { code: 1 },
          },
        },
      },
      {
        field: "_filterProvider",
        headerName: "Insurer",
        filterOnly: true,
        filterable: true,
        filter: {
          apiEntity: "order",
          field: "provider",
          label: "Insurer",
          width: 320,
          height: 300,
          populate: {
            model: "Provider",
            select: "name cname code shortName",
            labelField: "name",
            sort: { name: 1 },
          },
        },
      },
    ],
  };

  return (
    <>
      {/* <ReactJson src={auth()} /> */}
      {/* {clientId} */}
      {/* {userRole} */}
      {!clientId && <Text size="xs">{i18n.t("No Client Id")}</Text>}

      {clientId && (
        <PageList
          title=""
          apiEntity="order"
          initSort={{ by: "signedDate", order: "desc" }}
          hideSearchBar={true}
          tableSchema={tableSchema}
          formSchema={orderFormSchema}
          hideActionButton={true}
          tablePadding={-10}
        />
      )}
    </>
  );
};

export default ClientOrderHistory;
